import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_PATH,
});

const workspace = axios.create({
  baseURL: process.env.REACT_APP_WORKSPACE_API_PATH,
});

const ventures = axios.create({
  baseURL: process.env.REACT_APP_VENTURES_API,
  timeout: parseInt(process.env.REACT_APP_VENTURES_API_TIMEOUT || '5000'),
});

const pdfWorkspace = axios.create({
  baseURL: process.env.REACT_APP_PDF_WORKSPACE_API_PATH,
});

const apiNx = axios.create({
  baseURL: process.env.REACT_APP_API_NX_PATH,
});

const apiTranslate = axios.create({
  baseURL: process.env.REACT_APP_GOOGLE_TRANSLATE_PATH,
});

const setAuthorizationHeader = (authorizationToken: string) => {
  const authorizationType = authorizationToken.startsWith('jwt-mevo-') ? 'Bearer' : 'Basic';
  const token = `${authorizationType} ${authorizationToken.replace(/jwt-mevo-/gi, '')}`;
  const venturesBasic = `${authorizationType} ${process.env.REACT_APP_VENTURES_BASIC}`;

  api.interceptors.request.use((config) => {
    config.headers.Authorization = `${token}`;
    return config;
  });

  workspace.interceptors.request.use((config) => {
    config.headers.Authorization = `${token}`;
    return config;
  });

  ventures.interceptors.request.use((config) => {
    config.headers.Authorization = `${authorizationType === 'Basic' ? venturesBasic : token}`;
    return config;
  });

  pdfWorkspace.interceptors.request.use((config) => {
    config.headers.Authorization = `${token}`;
    return config;
  });
};

export const setPrescriptionIdHeader = (prescriptionId: number) => {
  if (!!(window as any).Cypress) return;

  api.interceptors.request.use((config) => {
    config.headers['x-prescription-id'] = `${prescriptionId}`;
    return config;
  });

  workspace.interceptors.request.use((config) => {
    config.headers['x-prescription-id'] = `${prescriptionId}`;
    return config;
  });

  ventures.interceptors.request.use((config) => {
    config.headers['x-prescription-id'] = `${prescriptionId}`;
    return config;
  });

  pdfWorkspace.interceptors.request.use((config) => {
    config.headers['x-prescription-id'] = `${prescriptionId}`;
    return config;
  });
};

export { setAuthorizationHeader, api, apiNx, apiTranslate, workspace, pdfWorkspace, ventures };
